import { render, staticRenderFns } from "./reviewDetailBox.vue?vue&type=template&id=d7e515f4"
import script from "./reviewDetailBox.vue?vue&type=script&lang=js"
export * from "./reviewDetailBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports